import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import * as echarts from 'echarts'
import Contextmenu from "vue-contextmenujs"

Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false
Vue.use(Antd);
Vue.use(ElementUI);
Vue.use(Contextmenu);
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')